import { BaseConfiguration } from './base-configuration.model';
import { MovementType } from './movement-type';
import { ReferenceSystem } from './reference-system.enum';

export class DynamicConfiguration extends BaseConfiguration {
  totalAnalysisTime: number;
  timeStep: number;
  timeStepForResultsGeneration: number;
  movementType: MovementType;

  constructor() {
    super();
    this.cutoff = 0;
    this.totalAnalysisTime = 70;
    this.displacementAndRotationNorm = true;
    this.maximumUnbalancedForce = true;
    this.forceAndMomentumNorm = true;
    this.maximumUnbalancedMoment = false;
    this.maxNumberOfIterations = 20;
    this.convergenceErrorTolerance = 0.001;
    this.timeStep = 0.1;
    this.timeStepForResultsGeneration = 0.5;
    this.maxUnbalancedForce = 1;
    this.maxUnbalancedMoment = 1;
    this.referenceSystem = ReferenceSystem.LOCAL_FLOATING;
    this.movementType = MovementType.TIME_SERIES;
  }
}
